import { useEffect, useState } from 'react';
import { Drawer, DrawerContent } from '@/components/ui/drawer';
import { QuantityStepper } from '@/components/ui/quantity-stepper';
import { Button } from '@/components/ui/button';
import { useClientTranslation } from '@/lib/core/i18n';

interface ChooseQuantitySheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  maxQuantity: number;
  onConfirm: (quantity: number) => void;
}

/**
 * Bottom sheet for picking a quantity — used instead of `ChooseSizeSheet` for
 * product sections where size selection is not applicable (Home, Fragrances)
 * but buying more than one unit is expected.
 */
export function ChooseQuantitySheet({
  open,
  onOpenChange,
  maxQuantity,
  onConfirm,
}: ChooseQuantitySheetProps) {
  const t = useClientTranslation();
  const [quantity, setQuantity] = useState(1);

  useEffect(() => {
    if (open) setQuantity(1);
  }, [open]);

  return (
    <Drawer open={open} onOpenChange={onOpenChange} showSwipeHandle>
      <DrawerContent className="max-h-[80vh]">
        <div data-base-ui-swipe-ignore className="flex flex-1 flex-col overflow-y-auto">
          <div className="flex flex-col px-4 pt-4">
            <h2 className="font-pp-neue-montreal text-jncquoi-neutral-1000 text-[12px] leading-none font-normal tracking-[0.5px] uppercase">
              {t('App.Shop.ChooseQuantity')}
            </h2>
          </div>

          <div className="flex px-4 py-8">
            <QuantityStepper value={quantity} min={1} max={maxQuantity} onChange={setQuantity} fullWidth />
          </div>

          <div className="px-4 pb-10.5">
            <Button
              variant="primary-solid"
              palette="dark"
              size="md"
              className="w-full"
              disabled={maxQuantity <= 0}
              onClick={() => onConfirm(quantity)}
            >
              {t('App.Shop.AddToBag')}
            </Button>
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
}
